import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './empty-comment.scss';
import withTranslate from '../../hoc/with-translate';

const EmptyComment = ({ onClick, onMouseDown, t }) => {
  const props = { onClick, onMouseDown };
  return (
    <article
      className={classNames(
        styles.comment,
        'forum-card-background-color',
        'forum-text-color',
        'empty-comment',
      )}
      {...props}
    >
      <div className={styles.text}>{t('empty-comment.be-te-first')}</div>
    </article>
  );
};

EmptyComment.propTypes = {
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  t: PropTypes.func,
};

export default withTranslate(EmptyComment);
